var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24List = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M3 7c0-.552.448-1 1-1s1 .448 1 1-.448 1-1 1-1-.448-1-1zm0 5c0-.552.448-1 1-1s1 .448 1 1-.448 1-1 1-1-.448-1-1zm1 4c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm3.936-5h12.128c.515 0 .936.421.936.936v.128c0 .515-.42.936-.936.936H7.936C7.42 13 7 12.579 7 12.064v-.128c0-.515.42-.936.936-.936zm12.128 5H7.936c-.516 0-.936.421-.936.936v.128c0 .515.42.936.936.936h12.128c.515 0 .936-.421.936-.936v-.128c0-.515-.42-.936-.936-.936zM7.936 6h12.128c.515 0 .936.421.936.936v.128c0 .515-.42.936-.936.936H7.936C7.42 8 7 7.579 7 7.064v-.128C7 6.421 7.42 6 7.936 6z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24List, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_list.11b9a115.svg";
export { ForwardRef as ReactComponent };